import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  title: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    padding: theme.spacing(0.5),
  },
  themeGrid: {},
  titleGrid: {
    marginBottom: '15px',
  },
  address: {
    fontWeight: 'bold',
    padding: theme.spacing(0.5),
  },
  addressNumber: {
    marginRight: 15,
  },
  addressGrid: {
    backgroundColor: '#bdbdbd',
  },
  theme: {
    fontWeight: 'bold',
  },
  formControl: {
    height: '100%',
  },
  checklistThemeGrid: {
    height: 'auto',
  },
}));

export { useStyles };
